import React, { useState, useEffect, Fragment } from 'react';
import { Table } from 'react-bootstrap';

const Step3 = ({ headers, rows, selectedHeaders, setImportData, progress }) => {

    const handleData = () => {

        let data = [];

        rows.forEach(row => {
            let obj = {};

            selectedHeaders.forEach(header => {
                obj[header.key] = row[headers.indexOf(header.value)];
            });

            data.push(obj);
        });

        setImportData(data);

    }

    useEffect(() => {
        handleData();
    }, [rows]);

    return (
        <Fragment>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {selectedHeaders.map((header, index) => (
                            <th key={index}>{header.key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>
                            {selectedHeaders.map((header, index) => (
                                <td key={index}>{row[headers.indexOf(header.value)]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Fragment>
    )

}

export default Step3;
